export const toggleImageHeaderVisibility = (isVisible: boolean) => !isVisible;
